import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Icon from './Icon';

const NAV_ITEMS = [
  { to: '/',         icon: 'icon-home2.png',   label: 'Home',     end: true },
  { to: '/clients',  icon: 'nav-clients.png',  label: 'Clients'            },
  { to: '/schedule', icon: 'nav-schedule.png', label: 'Schedule'           },
  { to: '/invoices', icon: 'nav-invoices.png', label: 'Invoices'           },
];

export default function BottomNav() {
  const { trainer } = useAuth();
  const hasBrandLogo = Boolean(trainer?.brand_logo_url);
  const businessName = trainer?.business_name || trainer?.name || 'Win/R';

  return (
    <nav className="sidebar-nav">
      <div className="sidebar-logo" style={{ justifyContent: 'center', padding: '18px 16px' }}>
        {hasBrandLogo ? (
          <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
            <img
              src={trainer.brand_logo_url}
              alt={businessName}
              style={{ maxWidth: 160, maxHeight: 60, objectFit: 'contain', display: 'block' }}
              onError={(e) => { e.target.style.display = 'none'; }}
            />
            <span style={{ fontSize: 11, color: 'var(--color-text-muted)', textAlign: 'center', fontWeight: 500 }}>
              {businessName}
            </span>
          </div>
        ) : (
          <img
            src="/icons/Win_R_Logo.png"
            alt="Win/R"
            style={{ width: '100%', maxWidth: 160, objectFit: 'contain', display: 'block' }}
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        )}
      </div>
      <div className="sidebar-items">
        {NAV_ITEMS.map(({ to, icon, label, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) => 'nav-item' + (isActive ? ' active' : '')}
          >
            <Icon name={icon} size={22} alt={label} className="nav-icon" style={{ backgroundColor: 'rgba(255,255,255,0.45)' }} />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
